import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

import { useSelectBusinessTypes, useSelectInterventionTypes } from '../../apis/startup/startup.selectors';
import { type FilterType } from '../Filters/filter.type';

export const useGenerateInterventionTypeFilter = (): FilterType[] => {
  const interventionTypes = useSelectInterventionTypes();
  const { t } = useTranslation();
  const ibterventionTypesFilters = useMemo(
    () =>
      interventionTypes.map((interventionType): FilterType => ({
        id: interventionType.id,
        label: t(`intervention.type.${interventionType.id}`),
        selected: true,
      })),
    []
  );

  return ibterventionTypesFilters;
};

export const useGenerateInterventionBusinessTypes = (): FilterType[] => {
  const { t } = useTranslation();
  const businessTypes = useSelectBusinessTypes();
  const businessTypesFilters = useMemo(
    () =>
      businessTypes.map((businessType): FilterType => {
        return { id: businessType.id, label: t(`business.type.choice.type.${businessType.id}`), selected: true };
      }),
    []
  );
  return businessTypesFilters;
};
